import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';
import React from 'react';
import { motion } from 'framer-motion';

const CallToActionSection = () => {
	const ctaBlocks = [
		{
			id: 1,
			title: 'FIND A LAWYER',
			description:
				'Connect with our expert attorneys specializing in Commercial Law, Real Estate, Family Law, Criminal Defense, and more. Get personalized legal guidance from our experienced team.',
			buttonText: 'MEET OUR ATTORNEYS',
			buttonLink: '/attorneys',
			bgColor: 'bg-[#800020]',
			icon: 'Users',
		},
		{
			id: 2,
			title: 'LEGAL SERVICES',
			description:
				'Access our comprehensive legal services including document review, contract drafting, legal consultations, and case representation across 17 practice areas.',
			buttonText: 'VIEW SERVICES',
			buttonLink: '/practice-areas',
			bgColor: 'bg-[#DB954E]',
			icon: 'Scale',
		},
		{
			id: 3,
			title: 'GET HELP NOW',
			description:
				"Need immediate legal assistance? Contact our team for urgent matters or to schedule an appointment. We're here to help.",
			buttonText: 'CONTACT US',
			buttonLink: '/contact',
			bgColor: 'bg-gray-800',
			icon: 'Phone',
		},
	];

	return (
		<section className='py-0'>
			<div className='grid grid-cols-1 md:grid-cols-3'>
				{ctaBlocks.map((block, index) => (
					<motion.div
						key={block.id}
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: index * 0.2 }}
						viewport={{ once: true }}
						className={`${block.bgColor} p-8 md:p-12 text-center min-h-[400px] flex flex-col justify-center items-center relative overflow-hidden`}
					>
						{/* Background Pattern */}
						<div className='absolute inset-0 opacity-10'>
							<div className='absolute top-4 right-4 w-16 h-16 bg-white rounded-full'></div>
							<div className='absolute bottom-4 left-4 w-12 h-12 bg-white rounded-lg'></div>
						</div>

						<motion.div
							initial={{ scale: 0.8 }}
							whileInView={{ scale: 1 }}
							transition={{ duration: 0.5, delay: index * 0.2 + 0.3 }}
							viewport={{ once: true }}
							className='space-y-6 relative z-10'
						>
							{/* Icon */}
							<div className='w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto'>
								<Icon name={block.icon} size={32} color='white' />
							</div>

							{/* Title */}
							<h3 className='font-source font-bold text-xl md:text-2xl text-white uppercase tracking-wide'>
								{block.title}
							</h3>

							{/* Description */}
							<p className='font-source text-sm md:text-base text-white/90 leading-relaxed max-w-sm mx-auto'>
								{block.description}
							</p>

							{/* Button */}
							<Link to={block.buttonLink}>
								<Button
									variant='outline'
									className='border-2 border-white text-white hover:bg-white hover:text-gray-800 font-source font-semibold px-6 py-3 text-sm uppercase tracking-wide transition-all duration-300 transform hover:scale-105'
								>
									{block.buttonText}
								</Button>
							</Link>
						</motion.div>
					</motion.div>
				))}
			</div>
		</section>
	);
};

export default CallToActionSection;
